import dayjs from "dayjs";

/**
 * @param {Object} dates
 */
export const buildAvailableSchedules = dates => {
  const dateNow = dayjs().unix();
  const schedules = {};

  for (const date in dates) {
    /** @type {Object} */
    const schedule = dates[date];
    if (!schedule.items) {
      continue;
    }

    const items = [];
    for (const time in schedule.items) {
      if (schedule.items[time].schedule && schedule.items[time].ts > dateNow) {
        items.push(schedule.items[time]);
      }
    }

    if (!items.length) {
      continue;
    }

    schedules[date] = {
      ...schedule,
      items,
    };
  }

  return schedules;
};
